import React from "react";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";

const DimmerComponent = ({ className }) => {
    return (
        <Dimmer className={className ? className : ""} inverted active>
            <Loader size="big" />
        </Dimmer>
    );
};

export default DimmerComponent;
